import { render, staticRenderFns } from "./BaseAppLogo.vue?vue&type=template&id=5fc02200&"
import script from "./BaseAppLogo.vue?vue&type=script&lang=js&"
export * from "./BaseAppLogo.vue?vue&type=script&lang=js&"
import style0 from "./BaseAppLogo.vue?vue&type=style&index=0&id=5fc02200&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports